var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RecycleScroller',{style:({height: _vm.height+'px'}),attrs:{"items":_vm.items,"item-size":22,"key-field":"index"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('UploadItem',{attrs:{"item":item,"percent":100,"stats":_vm.status}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }